import { Routes } from '@angular/router';

import { UnderConstructionComponent } from './components/under-construction';
import { WebComponent } from './web.component';

export const ROUTES: Routes = [
  {
    path: '',
    component: WebComponent,
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
      },
      {
        path: 'home',
        loadChildren: './modules/+home#HomeModule'
      },
      {
        path: 'about-us',
        loadChildren: './modules/+about-us#AboutUsModule'
      },
      {
        path: 'our-expertise',
        loadChildren: './modules/+our-expertise#OurExpertiseModule'
      },
      {
        path: 'expertise',
        loadChildren: './modules/+expertise-detail#ExpertiseDetailModule'
      },
      {
        path: 'our-network',
        loadChildren: './modules/+our-network#OurNetworkModule'
      },
      {
        path: 'career',
        loadChildren: './modules/+career#CareerModule'
      },
      {
        path: 'locations',
        loadChildren: './modules/+locations#LocationsModule'
      },
      {
        path: 'contact-us',
        loadChildren: './modules/+contact-us#ContactUsModule'
      },
      {
        path: 'pages',
        loadChildren: './modules/+page#PageModule'
      },
      {
        path: 'our-strength',
        loadChildren: './modules/+our-strength#OurStrengthModule'
      },
      {
        path: 'search',
        loadChildren: './modules/+search-result#SearchResultModule'
      },
      {
        path: ':permalink',
        loadChildren: './modules/+page#PageModule'
      }
    ]
  }
];


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+web/web.routes.ts